var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAlandIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4488 20.1739C31.8075 18.843 32 17.4441 32 15.9999C32 14.5557 31.8075 13.1569 31.4488 11.826L14.6087 0.060791C11.4824 0.330166 8.61344 1.49829 6.26088 3.30585L0.551188 11.826C0.1925 13.1569 0 14.5557 0 15.9999C0 17.4357 0.190188 18.8269 0.544875 20.1507L6.26081 28.694C8.61337 30.5015 11.4823 31.6697 14.6086 31.939L31.4488 20.1739Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 20.1738C1.47653 23.6088 3.51684 26.5859 6.26047 28.694V20.1738H0.550781Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6083 31.939C15.0669 31.9785 15.5307 31.9999 15.9996 31.9999C23.392 31.9999 29.6124 26.9861 31.4484 20.1738H14.6083V31.939Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4484 11.8261C29.6124 5.01381 23.392 0 15.9996 0C15.5307 0 15.0669 0.021375 14.6083 0.060875V11.8261H31.4484Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26047 3.30591C3.51684 5.41403 1.47653 8.3911 0.550781 11.826H6.26047V3.30591Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 13.9131H12.5218H12.5218V0.380371C11.0431 0.708246 9.64131 1.23968 8.34781 1.9455V13.9131H0.135438C0.046375 14.5962 0 15.2927 0 16.0001C0 16.7074 0.046375 17.4039 0.135438 18.087H8.34775H8.34781V30.0546C9.64131 30.7603 11.0431 31.2919 12.5218 31.6197V18.0872V18.0871H31.8646C31.9535 17.4039 32 16.7074 32 16.0001C32 15.2927 31.9535 14.5962 31.8646 13.9131Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAlandIslands);
export default __webpack_public_path__ + "static/media/flag_aland_islands.ca476856273c0344d447f544b9f8d4d9.svg";
export { ForwardRef as ReactComponent };